import "./App.css";
import Home from "./pages/Home";

function App() {
  return (
    <div className="w-full lg:max-w-6xl  m-auto">
      <Home />
    </div>
  );
}

export default App;
